import PropTypes from "prop-types";
import { Button, styled, Typography } from "@mui/material";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import CancelIcon from "@mui/icons-material/Cancel";
import { useTranslation } from "react-i18next";
import "./index.css";
const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    "& .MuiDialogContent-root": {
        padding: theme.spacing(2),
    },
    "& .MuiDialogActions-root": {
        padding: theme.spacing(1),
    },
}));

function BootstrapDialogTitle(props: any) {
    const { children, onClose, ...other } = props;

    return (
        <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
            {children}
            {onClose ? (
                <IconButton
                    aria-label="close"
                    onClick={onClose}
                    sx={{
                        position: "absolute",
                        right: 8,
                        top: 8,
                        color: (theme) => theme.palette.grey[500],
                    }}
                >
                    <CloseIcon />
                </IconButton>
            ) : null}
        </DialogTitle>
    );
}

BootstrapDialogTitle.propTypes = {
    children: PropTypes.node,
    onClose: PropTypes.func.isRequired,
};

export default function QRCodeScanDialog({ open, offCam, onClose, is_success, coupon_code, msg_code }: any) {
    const { t } = useTranslation();
    const goToRewardPage = () => {
        onClose();
        offCam();
    };
    const success_message = [t("scanQRSuccessMessage"), t("scanQRSuccessDetailMessage")];
    const fail_message = [t("scanQRFailMessage"), t("scanQRFailDetailMessage")];
    return (
        <BootstrapDialog className="scanner_dialog" open={open} onClose={onClose}>
            {
                is_success ? (
                    <>
                        <Typography variant="h5" component="h5" className="qr_scan_result_message">
                            {success_message[0]}
                        </Typography>
                        <Typography className="qr_scan_detail_message">
                            {!msg_code ? success_message[1] : t(msg_code) }
                        </Typography>
                    </>
                ) : (
                    <>
                        <Typography variant="h5" component="h5" className="qr_scan_result_message">
                            {fail_message[0]}
                        </Typography>
                        <Typography className="qr_scan_detail_message">
                            {!msg_code ? fail_message[1] : t(msg_code) }
                        </Typography>
                    </>
                )
            }
            <Typography className="qr_scan_coupon_code">
                <p>{coupon_code}</p>
            </Typography>
            <Typography className="qr_scan_icon">
                {
                    is_success ? (
                        <CheckCircleOutlineIcon className="success"/>
                    ) : (
                        <CancelIcon className="fail"/>
                    )
                }
            </Typography>
            <Button variant="contained" onClick={goToRewardPage}>OK</Button>
        </BootstrapDialog>
    );
}
